/*
  DELIVERY ESTIMATE — 25 Oct 2026 (Dillon: "build on staging").

  Abandoned checkouts showed shoppers seeing freight for the first time at checkout. This makes the
  delivery price visible earlier, from ONE remembered ZIP:

  1. Remember the ZIP. Typed once anywhere (product-page calculator, cart calculators, the
     email-my-invoice form, or the delivery line itself) and kept in localStorage `ctxShipZip`
     ({zip, state}). The state comes from the ZIP (ZIP3 table below), so nobody picks a state.
  2. Cart drawer + cart page: [data-ctx-dl] (snippets/ctx-delivery-line) shows
     "Delivery to 78701 · from $325" and an estimated total, right above Checkout. Quotes the WHOLE
     cart with GET /cart/shipping_rates.json, which reads rates without changing the cart.
  3. Product page: [data-ctx-pdl] under the price shows "Delivery to 78701 from $X" for that one item,
     from n8n "Ship quote (product page)" (webhook bag-ship-quote, draftOrderCalculate, read-only),
     so the shopper's cart is never emptied to get a single-item quote.
  4. Prefills every existing calculator with the remembered ZIP/state.

  The cart drawer re-renders with innerHTML, so everything here is delegated / re-applied by a
  MutationObserver; no inline scripts live in the snippets.
*/
(function () {
  'use strict';
  if (window.__ctxDeliveryEstimate) return;
  window.__ctxDeliveryEstimate = true;

  var KEY = 'ctxShipZip';
  var QUOTE_URL = 'https://buildagym.app.n8n.cloud/webhook/bag-ship-quote';
  var PHONE = '(512) 591-8553';
  var ZIP3 = [["733","733","TX"],["005","005","NY"],["010","027","MA"],["028","029","RI"],["030","038","NH"],["039","049","ME"],["050","059","VT"],["060","069","CT"],["070","089","NJ"],["100","149","NY"],["150","196","PA"],["197","199","DE"],["200","205","DC"],["206","219","MD"],["220","246","VA"],["247","268","WV"],["270","289","NC"],["290","299","SC"],["300","319","GA"],["320","349","FL"],["350","369","AL"],["370","385","TN"],["386","397","MS"],["398","399","GA"],["400","427","KY"],["430","459","OH"],["460","479","IN"],["480","499","MI"],["500","528","IA"],["530","549","WI"],["550","567","MN"],["569","569","DC"],["570","577","SD"],["580","588","ND"],["590","599","MT"],["600","629","IL"],["630","658","MO"],["660","679","KS"],["680","693","NE"],["700","715","LA"],["716","729","AR"],["730","749","OK"],["750","799","TX"],["800","816","CO"],["820","831","WY"],["832","838","ID"],["840","847","UT"],["850","865","AZ"],["870","884","NM"],["885","885","TX"],["889","898","NV"],["900","961","CA"],["967","968","HI"],["970","979","OR"],["980","994","WA"],["995","999","AK"]];
  var NAMES = { AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming' };

  function stateFor(zip) {
    if (!/^\d{5}$/.test(zip)) return '';
    var z3 = zip.slice(0, 3);
    for (var i = 0; i < ZIP3.length; i++) if (z3 >= ZIP3[i][0] && z3 <= ZIP3[i][1]) return ZIP3[i][2];
    return '';
  }
  function cleanZip(v) { return String(v || '').replace(/\D/g, '').slice(0, 5); }
  function getLoc() {
    try {
      var o = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (o && /^\d{5}$/.test(o.zip) && o.state) return o;
    } catch (e) {}
    return null;
  }
  function setLoc(zipRaw) {
    var zip = cleanZip(zipRaw);
    var st = stateFor(zip);
    if (!st) return false;
    var cur = getLoc();
    if (cur && cur.zip === zip) return true;
    try { localStorage.setItem(KEY, JSON.stringify({ zip: zip, state: st, t: Date.now() })); } catch (e) {}
    renderAll();
    return true;
  }
  function money(n) {
    n = Number(n);
    if (!isFinite(n)) return '';
    var s = n.toFixed(2).replace(/\.00$/, '');
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function isPickup(name) { return /pick\s*up|pickup/i.test(name || ''); }

  /* From a list of {t, p}: cheapest paid delivery, plus whether free pickup exists. */
  function summarize(rates) {
    var paid = rates.filter(function (r) { return !isPickup(r.t) && r.p > 0; }).sort(function (a, b) { return a.p - b.p; });
    var free = rates.filter(function (r) { return !isPickup(r.t) && r.p === 0; });
    var pickup = rates.some(function (r) { return isPickup(r.t); });
    var best = free[0] || paid[0] || null;
    return { best: best, pickup: pickup };
  }

  /* ---------------- Cart (drawer + page) ---------------- */
  var cartCache = {};
  function quoteCart(loc, sig) {
    var k = loc.zip + '|' + sig;
    if (cartCache[k]) return cartCache[k];
    cartCache[k] = fetch('/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(loc.zip) +
      '&shipping_address[country]=US&shipping_address[province]=' + encodeURIComponent(loc.state), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { shipping_rates: [] }; })
      .then(function (d) {
        return (d && d.shipping_rates || []).map(function (r) { return { t: r.name, p: parseFloat(r.price) }; })
          .filter(function (r) { return isFinite(r.p); });
      })
      .catch(function () { delete cartCache[k]; return null; });
    return cartCache[k];
  }

  function zipForm(label) {
    return '<form class="ctx-dl__form" data-ctx-dl-form novalidate>' +
      '<label class="ctx-dl__label" for="ctx-dl-zip-' + (++uid) + '">' + esc(label) + '</label>' +
      '<span class="ctx-dl__entry"><input id="ctx-dl-zip-' + uid + '" class="ctx-dl__input" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="5" placeholder="ZIP code" data-ctx-dl-zip>' +
      '<button type="submit" class="ctx-dl__go">See price</button></span>' +
      '<span class="ctx-dl__err" data-ctx-dl-err role="alert"></span></form>';
  }
  var uid = 0;

  function renderCartLine(el) {
    var loc = getLoc();
    var total = parseInt(el.getAttribute('data-cart-total'), 10) || 0;
    var count = parseInt(el.getAttribute('data-cart-count'), 10) || 0;
    var where = el.getAttribute('data-where') || 'drawer';
    if (!count) { el.hidden = true; return; }
    el.hidden = false;
    if (!loc || el.getAttribute('data-editing') === '1') {
      el.innerHTML = zipForm('Delivery to your ZIP');
      if (el.getAttribute('data-editing') === '1') { var i = el.querySelector('input'); if (i) { i.value = loc ? loc.zip : ''; i.focus(); } }
      return;
    }
    var sig = count + ':' + total;
    el.setAttribute('data-sig', sig);
    el.innerHTML = '<div class="ctx-dl__row"><span class="ctx-dl__label">Delivery to <b>' + esc(loc.zip) + '</b></span>' +
      '<span class="ctx-dl__val ctx-dl__val--loading">Checking…</span></div>';
    quoteCart(loc, sig).then(function (rates) {
      if (el.getAttribute('data-sig') !== sig) return; // cart changed meanwhile
      var allBtn = where === 'drawer'
        ? '<button type="button" class="ctx-dl__link" data-cart-open-calc aria-haspopup="dialog">All options</button>'
        : '<a class="ctx-dl__link" href="#ctx-cart-shipcalc-title">All options</a>';
      var change = '<button type="button" class="ctx-dl__link" data-ctx-dl-change>Change ZIP</button>';
      if (!rates || !rates.length) {
        el.innerHTML = '<div class="ctx-dl__row"><span class="ctx-dl__label">Delivery to <b>' + esc(loc.zip) + '</b></span>' +
          '<span class="ctx-dl__val">Quoted for you</span></div>' +
          '<p class="ctx-dl__sub">Call ' + PHONE + ' or use "Email &amp; print my invoice" and we will quote delivery. ' + change + '</p>';
        return;
      }
      var s = summarize(rates);
      if (!s.best) {
        el.innerHTML = '<div class="ctx-dl__row"><span class="ctx-dl__label">Delivery to <b>' + esc(loc.zip) + '</b></span>' +
          '<span class="ctx-dl__val">Free pickup</span></div><p class="ctx-dl__sub">' + change + ' · ' + allBtn + '</p>';
        return;
      }
      var est = total / 100 + s.best.p;
      el.innerHTML = '<div class="ctx-dl__row"><span class="ctx-dl__label">Delivery to <b>' + esc(loc.zip) + '</b></span>' +
        '<span class="ctx-dl__val">' + (s.best.p === 0 ? 'Free' : 'from <b>' + money(s.best.p) + '</b>') + '</span></div>' +
        '<div class="ctx-dl__row ctx-dl__row--total"><span>Total with delivery</span><span><b>' + money(est) + '</b> + tax</span></div>' +
        '<p class="ctx-dl__sub">' + esc(s.best.t) + (s.pickup ? ' · or free pickup' : '') + ' · ' + change + ' · ' + allBtn + '</p>';
    });
  }

  /* ---------------- Product page ---------------- */
  function pdpCacheGet(k) {
    try {
      var o = JSON.parse(sessionStorage.getItem('ctxPdl:' + k) || 'null');
      if (o && Date.now() - o.t < 30 * 60 * 1000) return o.r;
    } catch (e) {}
    return null;
  }
  function pdpCacheSet(k, r) { try { sessionStorage.setItem('ctxPdl:' + k, JSON.stringify({ t: Date.now(), r: r })); } catch (e) {} }

  /* Product page delivery bar (25 Oct 2026, Dillon's mock): the .cp-shipbar markup is server-rendered in
     custom-product.liquid; this only fills the shipping line and swaps between the ZIP box (no ZIP yet, or
     "Change ZIP code" clicked) and the Change button. */
  function renderPdp(el) {
    var loc = getLoc();
    var host = el.closest('[data-ctx-pdl-host]') || el.parentNode;
    var box = host.querySelector('[data-ctx-pdl-formbox]');
    var chg = host.querySelector('[data-ctx-pdl-change]');
    var idInput = document.getElementById('cp-variant-id');
    var v = (idInput && idInput.value) || el.getAttribute('data-variant');
    if (!v) return;
    if (!loc || el.getAttribute('data-editing') === '1') {
      el.removeAttribute('data-k');
      el.innerHTML = '<span class="ctx-pdl__title">Delivery to ' + (loc ? '<b>' + esc(loc.zip) + '</b>' : 'your ZIP') + '</span>';
      if (chg) chg.hidden = true;
      if (box) box.hidden = false;
      return;
    }
    if (box) box.hidden = true;
    if (chg) chg.hidden = false;
    var k = v + '|' + loc.zip;
    el.setAttribute('data-k', k);
    var title = '<span class="ctx-pdl__title">Delivery to <b>' + esc(loc.zip) + '</b></span>';
    var line = function (html) { el.innerHTML = title + '<span class="ctx-pdl__price">' + html + '</span>'; };
    var draw = function (rates) {
      if (el.getAttribute('data-k') !== k) return;
      if (rates === null) { line('Shipping cost shown at checkout'); return; }
      if (!rates.length) { line('We will quote shipping: ' + PHONE); return; }
      var s = summarize(rates);
      if (!s.best) { line('Free pickup'); return; }
      line((s.best.p === 0 ? '<b>Free</b> shipping' : 'Shipping from <b>' + money(s.best.p) + '</b>') + (s.pickup ? ' or free pickup' : ''));
    };
    var cached = pdpCacheGet(k);
    if (cached) { draw(cached); return; }
    line('Checking shipping…');
    fetch(QUOTE_URL + '?v=' + encodeURIComponent(v) + '&q=1&zip=' + encodeURIComponent(loc.zip))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.ok) { draw(null); return; }
        pdpCacheSet(k, d.rates);
        draw(d.rates);
      })
      .catch(function () { draw(null); });
  }



  /* ---------------- Prefill + capture in existing calculators ---------------- */
  /* A calculator's ZIP is filled when it is empty or still holds the previously remembered ZIP (so a new ZIP
     follows everywhere, but a ZIP the shopper typed there is never overwritten). Its state select is set to match
     whenever its ZIP is the remembered one - selects default to a real state (e.g. Alabama), so "only when empty"
     left 78701 paired with Alabama. */
  var ZIP_SEL = '#ShippingCalculator-Zip, [data-ctx-cart-ship-zip], [data-cp-shipcalc-zip], .ctx-inv-dlg input[name="zip"]';
  var PAIRS = [
    ['#ShippingCalculator-Zip', '#ShippingCalculator-Country', function (st) { return 'US-' + st; }],
    ['[data-ctx-cart-ship-zip]', '[data-ctx-cart-ship-state]', function (st) { return st; }],
    ['[data-cp-shipcalc-zip]', '[data-cp-shipcalc-state]', function (st) { return NAMES[st] || ''; }]
  ];
  var prevZip = null;
  function prefill() {
    var loc = getLoc();
    if (!loc) return;
    var zips = document.querySelectorAll(ZIP_SEL);
    for (var i = 0; i < zips.length; i++) if (!zips[i].value || zips[i].value === prevZip) zips[i].value = loc.zip;
    for (var p = 0; p < PAIRS.length; p++) {
      var zs = document.querySelectorAll(PAIRS[p][0]), ss = document.querySelectorAll(PAIRS[p][1]);
      for (var k = 0; k < zs.length && k < ss.length; k++) {
        var want = PAIRS[p][2](loc.state);
        if (zs[k].value === loc.zip && want && ss[k].value !== want && [].some.call(ss[k].options, function (o) { return o.value === want; })) ss[k].value = want;
      }
    }
    prevZip = loc.zip;
  }

  var CAPTURE = ZIP_SEL;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(CAPTURE) && cleanZip(t.value).length === 5) setLoc(t.value);
  });

  /* ---------------- Delivery-line interactions ---------------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('[data-ctx-dl-form]');
    if (!f) return;
    e.preventDefault();
    var input = f.querySelector('[data-ctx-dl-zip]');
    var err = f.querySelector('[data-ctx-dl-err]');
    var zip = cleanZip(input && input.value);
    if (zip.length !== 5 || !stateFor(zip)) { if (err) err.textContent = 'Enter a 5-digit US ZIP code.'; if (input) input.focus(); return; }
    var line = f.closest('[data-ctx-dl]') || (f.closest('[data-ctx-pdl-host]') || document).querySelector('[data-ctx-pdl]');
    if (line) line.removeAttribute('data-editing');
    var cur = getLoc();
    if (cur && cur.zip === zip) renderAll(); else setLoc(zip);
  });
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-ctx-dl-change]');
    if (c) { var line = c.closest('[data-ctx-dl]'); if (line) { line.setAttribute('data-editing', '1'); renderCartLine(line); } return; }
    var p = e.target.closest && e.target.closest('[data-ctx-pdl-change]');
    if (p) {
      /* 25 Oct 2026: "Change ZIP code" opens the bar's ZIP box, prefilled. */
      var ph = p.closest('[data-ctx-pdl-host]') || document;
      var pl = ph.querySelector('[data-ctx-pdl]');
      if (pl) {
        pl.setAttribute('data-editing', '1'); renderPdp(pl);
        var pi = ph.querySelector('[data-ctx-pdl-formbox] input');
        if (pi) { var cur = getLoc(); if (cur) pi.value = cur.zip; pi.focus(); pi.select(); }
      }
    }
  });
  /* Variant switch on the product page: custom-product.js sets #cp-variant-id's value without firing an event, so watch it. */
  var lastVariant = null;
  setInterval(function () {
    var el = document.querySelector('[data-ctx-pdl]'), id = document.getElementById('cp-variant-id');
    if (!el || !id) return;
    if (lastVariant !== null && id.value !== lastVariant) renderPdp(el);
    lastVariant = id.value;
  }, 800);

  function renderAll() {
    var lines = document.querySelectorAll('[data-ctx-dl]');
    for (var i = 0; i < lines.length; i++) renderCartLine(lines[i]);
    var p = document.querySelectorAll('[data-ctx-pdl]');
    for (var j = 0; j < p.length; j++) renderPdp(p[j]);
    prefill();
  }

  /* The drawer and cart page re-render with innerHTML: render any delivery line that appears. */
  var pending = false;
  new MutationObserver(function (muts) {
    if (pending) return;
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-ctx-dl], [data-ctx-pdl], .ctx-inv-dlg, #CartDrawerShipCalcModal') || n.querySelector('[data-ctx-dl], [data-ctx-pdl], .ctx-inv-dlg'))) {
          pending = true;
          setTimeout(function () {
            pending = false;
            var lines = document.querySelectorAll('[data-ctx-dl]');
            for (var k = 0; k < lines.length; k++) {
              var sig = (lines[k].getAttribute('data-cart-count') || '') + ':' + (lines[k].getAttribute('data-cart-total') || '');
              if (!lines[k].innerHTML.trim() || lines[k].getAttribute('data-sig') !== sig) renderCartLine(lines[k]);
            }
            prefill();
          }, 30);
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('storage', function (e) { if (e.key === KEY) renderAll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll); else renderAll();
})();
